import React from "react";
import classNames from "classnames";

export const BrandButton = ({
  children,
  variant = "primary",
  type = "button",
  className = "",
  disabled = false,
  ...rest
}) => {
  const base =
    "px-4 py-3 font-bold leading-tight transition ease-in-out duration-150";
  const primary =
    "brand-primary-btn inline-flex justify-center items-center w-full";
  const outline =
    "brand-outline-btn inline-flex justify-center items-center w-full";

  return (
    <button
      type={type}
      disabled={disabled}
      className={classNames(base, variant === "outline" ? outline : primary, className)}
      {...rest}
    >
      {children}
    </button>
  );
};
